import { apiDelete, apiGet, apiPost } from 'api/service';

export const listConsoleKeys = () => apiGet('/api/auth/api-keys/');
export const createConsoleKey = (name) => apiPost('/api/auth/api-keys/', { name });
export const revokeConsoleKey = (id) => apiDelete(`/api/auth/api-keys/${id}/`);
